import React from 'react'
import Spinner from 'components/ui/Spinner'

const DefaultLoading = props => {
	const {
		spinnerClass,
		loading,
		children
	} = props

	return (
		<div className="">
			{loading ?
				<Spinner className={spinnerClass} size={40} />
				:
				{children}
			}
		</div>
	)
}

const CoveredLoading = props => {
	const {
		spinnerClass,
		children,
		loading
	} = props


	return (
		<div className="wrapper">
			{children}
			{loading ?
				<div className='wrapper-loader'>
					<Spinner className={spinnerClass} size={40} />
				</div>
				: ''
			}
		</div>
	)
}

const Loading = props => {

	switch (props.type) {
		case 'default':
			return <DefaultLoading {...props} />
		case 'cover':
			return <CoveredLoading {...props} />
		default:
			return <DefaultLoading {...props} />
	}
}
export default Loading
